import api from '../../../api/_patient'

export default {
    getInfoPersonneAPrevenir(patient_id) {
        return new Promise((resolve, reject) => {
            api.getInfoPersonneAPrevenir(patient_id).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getListeTousPatients(data) {
        return new Promise((resolve, reject) => {
            api.getListeTousPatients(data).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getListePatients() {
        return new Promise((resolve, reject) => {
            api.patients().then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getInfoAssurancePatient(patient_id) {
        return new Promise((resolve, reject) => {
            api.getInfoAssurancePatient(patient_id).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
}